import { useTranslation } from 'react-i18next';
import { ExamLanding } from './ExamLanding';

// Referee "Rule tests" landing — the rule_test exams for their federation + sport.
export function RuleTestsPage() {
  const { t } = useTranslation();
  return (
    <ExamLanding
      examType="rule_test"
      title={t('exams.ruleTestsPage.title')}
      subtitle={t('exams.ruleTestsPage.subtitle')}
    />
  );
}
